import React from 'react';

import { TextField } from 'new/elements/TextField';
import { useRegisterCapsule } from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/RegisterCapsuleModal/context/RegisterCapsuleModalContext';
import {
  CAPSULE_DESCRIPTION_MAX_LENGTH,
  CAPSULE_NAME_MAX_LENGTH,
} from 'new/modules/settings/capsules/utils/registerCapsuleStepOneSchema';
import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/RegisterCapsuleModal/components/InfoStep/InfoStep.module.scss';

const handleEventValue = (cb: (value: string) => void) => (event: { target: { value: string } }) =>
  cb(event.target.value);

const DESCRIPTION_HELPER_TEXT = 'Summarize the capsule purpose or usage.';

export function InfoStep() {
  const { state, actions } = useRegisterCapsule();
  const { capsuleName, capsuleDescription, nameError, descriptionError } = state;
  const { setCapsuleName, setCapsuleDescription } = actions;

  const defaultNameFieldHelperText = `Use lowercase letters, numbers, and hyphens. Start and end with a letter or number. ${CAPSULE_NAME_MAX_LENGTH} characters max.`;
  const nameFieldHelperText = nameError || defaultNameFieldHelperText;
  const descriptionCounter = `${capsuleDescription.length}/${CAPSULE_DESCRIPTION_MAX_LENGTH}`;
  const descriptionHelperText = (
    <span className={styles.descriptionHelper}>
      <span>{descriptionError || DESCRIPTION_HELPER_TEXT}</span>
      <span>{descriptionCounter}</span>
    </span>
  );

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <TextField
          fullWidth
          isRequired
          label="Name"
          placeholder="e.g. prod-us-east"
          value={capsuleName}
          error={nameError.length > 0}
          // Capsule names become the Helm release name, which must be a lowercase
          // DNS label. Force lowercase on input so uppercase can't be entered, and
          // stop the browser/OS from auto-capitalizing or autocorrecting.
          onChange={handleEventValue((value) => setCapsuleName(value.toLowerCase()))}
          helperText={nameFieldHelperText}
          inputProps={{ autoCapitalize: 'none', autoCorrect: 'off', spellCheck: false }}
        />
      </div>

      <div className={styles.section}>
        <TextField
          fullWidth
          isRequired
          label="Description *"
          placeholder="e.g. Handles production data processing"
          multiline
          rows={3}
          value={capsuleDescription}
          error={descriptionError.length > 0}
          onChange={handleEventValue(setCapsuleDescription)}
          helperText={descriptionHelperText}
        />
      </div>
    </div>
  );
}
